import { CITY_PATH_PARAMETER } from './const';

export const routePathWithCity = (path: string) => {
  return `/:${CITY_PATH_PARAMETER}?${path}`;
};
